const moveTo = (arr, fromIndex, toIndex) => {
  const element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
  return arr;
};

const confirmTarget = (target) => (target.nodeName === 'TD' ? target.parentElement : target);

const workWithClass = (element, newClass, defaultClassName, doWhat) => {
  if (!element.classList) return;
  let className = defaultClassName;
  if (newClass) className = newClass;
  if (doWhat === 'add') {
    element.classList.add(className);
  } else if (doWhat === 'remove') {
    element.classList.remove(className);
  }
};

export const draggable = {
  mounted: (el, binding) => {
    const element = el;
    element.draggable = true;
    element.ondragstart = (event) => {
      workWithClass(element, binding.value.dragClass, 'yita-draging', 'add');

      const index = Array.from(element.parentElement.children).indexOf(element);
      event.dataTransfer.setData('text', index);
      // event.dataTransfer.setData('text', self._scope['$index']);
    };
    element.ondragend = () => {
      workWithClass(element, binding.value.dragClass, 'yita-draging', 'remove');
    };
    element.ondrag = () => {
      // Do nothing
    };
  },
};

export const dropper = {
  mounted: (el, binding) => {
    const element = el;
    element.ondragenter = (event) => {
      let { target } = event;
      target = confirmTarget(target);
      // let index = Array.from(this.children).indexOf(target)
      workWithClass(target, element.attributes['drag-class'].value, 'yita-draging-zone', 'add');
    };
    element.ondragleave = (event) => {
      let { target } = event;
      target = confirmTarget(target);
      workWithClass(target, element.attributes['drag-class'].value, 'yita-draging-zone', 'remove');
    };
    element.ondragover = (event) => {
      event.preventDefault();
    };
    element.ondrop = (event) => {
      event.preventDefault();
      event.stopPropagation();
      const fromIndex = event.dataTransfer.getData('text');
      let { target } = event;
      while (target != null && !target.draggable) {
        target = target.parentElement;
      }
      target = confirmTarget(target);
      workWithClass(target, element.attributes['drag-class'].value, 'yita-draging-zone', 'remove');
      const toIndex = Array.from(element.children).indexOf(target);
      if (toIndex === -1) {
        console.warn('cannot find', target, 'in ', this);
      }
      const out = moveTo(binding.value.list, fromIndex, toIndex);

      // binding.value.list.splice(0, binding.value.list.length);
      binding.value.callback(out);
    };
  },
};

export default { draggable, dropper };
